const initLazyLoad = () => {
	if (typeof window.LazyLoad !== 'function') {
		return;
	}

	new window.LazyLoad({
		elements_selector: '.pr-lazy',
	});
};

document.addEventListener('swup:content:replace', initLazyLoad);
